import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <>
      {children}
        <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
